export default {
      id: "chevronup-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#chevronup",
      toString: function () {
        return this.url;
      }
    }